import React, { useEffect, useState } from "react";
import PaidIcon from "@mui/icons-material/Paid";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Chip from "@mui/material/Chip";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { LoadingButton } from "@mui/lab";
import AlertSnack from "../AlertSnack";
import MuiAlert from "@mui/material/Alert";
import CryptoJS from "crypto-js";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import server from "../../../functions/server";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { InputAdornment, Typography } from "@mui/material";
import { StyledDataGrid } from "./tableConfig/stylesTable";
import { ptBRGrid } from "./tableConfig/translateptBR";
import { useMediaQuery, useTheme } from "@mui/material";
import Card from "@mui/material/Card";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getGridStringOperators } from "@mui/x-data-grid";
import Cookies from "js-cookie";
import { supportNumber } from "../../../utils/supportNumber";
import InfoIcon from '@mui/icons-material/InfoOutlined';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Boletos(props) {
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [snackType, setSnackType] = useState("error");
  const [boletoVenc, setBoletoVenc] = useState(false);
  const [whatsappModal, setWhatsappModal] = useState(false);
  const [emailappModal, setEmailappModal] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [sendingWhatsapp, setSendingWhatsapp] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [whatsappError, setWhatsappError] = useState("");
  const [loadingAllBankSlips, setLoadingAllBankSlips] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [phoneError, setPhoneError] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [attemptedExtraDigits, setAttemptedExtraDigits] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimeout);
    };
  }, []);

  const validatePhone = (value) => {
    const phoneNumber = value.replace(/\D/g, "");

    if (!phoneNumber) {
      setPhoneError("O número de telefone é obrigatório");
      setIsPhoneValid(false);
      return false;
    }

    if (phoneNumber.length < 10) {
      setPhoneError("O número deve ter no mínimo 10 dígitos (DDD + número)");
      setIsPhoneValid(false);
      return false;
    }

    if (phoneNumber.length === 10 || phoneNumber.length === 11) {
      const ddd = phoneNumber.substring(0, 2);
      if (parseInt(ddd) < 11 || parseInt(ddd) > 99) {
        setPhoneError("DDD inválido");
        setIsPhoneValid(false);
        return false;
      }
    }

    setPhoneError("");
    setIsPhoneValid(true);
    return true;
  };

  const getDocument = () => {
    const impersonatedUser = localStorage.getItem("user");
    return impersonatedUser
      ? CryptoJS.AES.decrypt(impersonatedUser, "MedSys@341").toString(
          CryptoJS.enc.Utf8,
        )
      : localStorage.getItem("username");
  };

  const createBoletosFilter = (selectedRows) => {
    return selectedRows.reduce((acc, { nota, vencimento }) => {
      const existingNote = acc.find((item) => item.numeroNota === nota);
      if (existingNote) {
        existingNote.dataVencimentos.push(vencimento);
      } else {
        acc.push({
          numeroNota: nota,
          dataVencimentos: [vencimento],
        });
      }
      return acc;
    }, []);
  };

  const downloadPDF = (boleto) => {
    const link = window.document.createElement("a");
    const pdfContent = atob(boleto.pdf);
    const byteArray = new Uint8Array(pdfContent.length);

    for (let i = 0; i < pdfContent.length; i++) {
      byteArray[i] = pdfContent.charCodeAt(i);
    }

    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    link.href = url;
    link.download = `boleto_NF${
      boleto.invoiceNumber
    }_venc_${boleto.dueDate.replace(/\//g, "-")}.pdf`;
    link.click();

    window.URL.revokeObjectURL(url);
  };

  const sendBoletos = async (metodosEnvio) => {
    const document = getDocument();
    const boletosFilter = createBoletosFilter(selectedRows);

    const response = await fetch(server + "portalCliente/enviarBoletos", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("bearer"),
      },
      body: JSON.stringify({
        document,
        boletosFilter,
        metodosEnvio,
        selectedRows,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Falha ao enviar boletos");
    }

    return data;
  };

  const handleWhatsAppSend = async () => {
    if (!validatePhone(phone)) {
      return;
    }

    try {
      setSendingWhatsapp(true);
      setWhatsappError("");

      await sendBoletos({
        whatsapp: phone,
      });

      setWhatsappModal(false);
      setPhone("");
      setSnackType("success");
      setSnackMessage("Boleto(s) enviado(s) com sucesso via WhatsApp!");
      setOpenSnack(true);
    } catch (error) {
      setWhatsappError(
        error.message || "Falha ao enviar mensagem via WhatsApp",
      );
      setSnackType("error");
      setSnackMessage(
        `Erro interno (${error.status || 500}): Falha na conexão com o servidor`,
      );
      setOpenSnack(true);
    } finally {
      setSendingWhatsapp(false);
    }
  };

  const handleEmailSend = async () => {
    try {
      setSendingEmail(true);

      await sendBoletos({
        email: email,
      });

      setEmailappModal(false);
      setEmail("");
      setSnackType("success");
      setSnackMessage("Boleto(s) enviado(s) com sucesso via Email!");
      setOpenSnack(true);
    } catch (error) {
      setEmailError(error.message || "Falha ao enviar email");
      setSnackType("error");
      setSnackMessage(
        `Erro interno (${error.status || 500}): Falha na conexão com o servidor`,
      );
      setOpenSnack(true);
    } finally {
      setSendingEmail(false);
    }
  };

  const handleDownloadAllBankSlip = async () => {
    try {
      setLoadingAllBankSlips(true);
      setSnackType("info");
      setSnackMessage("Iniciando download dos boletos...");
      setOpenSnack(true);

      const document = getDocument();
      const boletosFilter = createBoletosFilter(selectedRows);

      const response = await fetch(server + "portalCliente/filtrarBoletos", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("bearer"),
        },
        body: JSON.stringify({
          document,
          boletosFilter,
          selectedRows,
        }),
      });

      const { error, success, boletos } = await response.json();

      if (!success) {
        throw new Error(error || "Falha ao baixar boletos");
      }

      boletos.forEach(downloadPDF);

      setSnackType("success");
      setSnackMessage(`${boletos.length} boletos baixados com sucesso!`);
      setOpenSnack(true);
    } catch (error) {
      console.error("Erro ao baixar boletos:", error);
      setSnackType("error");
      setSnackMessage(error.message || "Falha ao baixar boletos");
      setOpenSnack(true);
    } finally {
      setLoadingAllBankSlips(false);
    }
  };

  let dados = props.dados;

  try {
    dados = JSON.parse(props.dados);
  } catch {
    return (
      <>
        <LinearProgress />
      </>
    );
  }

  if (boletoVenc === true) {
    return (
      <>
        <IconButton onClick={() => setBoletoVenc(false)}>
          <ArrowBackIcon />
        </IconButton>
        <Alert severity="warning" sx={{ mt: 3 }}>
          O boleto não pôde ser gerado, entre em contato com o setor financeiro
          via financeiro@medsystems.com.br
        </Alert>
      </>
    );
  }

  let cons_boleto = async (
    numfin,
    codbanc,
    status,
    linha_digitavel,
    nossonum,
  ) => {
    let user = localStorage.getItem("user");
    user = CryptoJS.AES.decrypt(user, "MedSys@341");
    user = CryptoJS.enc.Utf8.stringify(user);

    if (status === "VENDOR") {
      return window.open(
        `https://wa.me/${supportNumber.whatsApp}/?text=Solicito a segunda via de boleto VENDOR`,
      );
    }

    if (status === "DAYCOVAL") {
      return downloadFile(linha_digitavel, "boleto.pdf");
    }

    let url = server + "portalCliente/consulta/boleto";

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + Cookies.get("bearer"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        jsonid: localStorage.getItem("token"),
        nufin: `${numfin}`,
        codbco: `${codbanc}`,
        linha_digitavel: linha_digitavel.replace(/\D/g, ""),
        status: "Em aberto",
        cnpj: user,
        nossonum: nossonum,
      }),
    })
      .then((resp) => resp.text())
      .then(function (reqres) {
        let resp = JSON.parse(reqres);

        if (resp.boleto === "") {
          return cons_boleto(
            numfin,
            codbanc,
            "Vencido",
            linha_digitavel,
            nossonum,
          );
        }
        const fileUrl = server + "arquivos/boleto/" + resp.boleto + ".pdf";

        fetch(fileUrl)
          .then((response) => response.blob())
          .then((blob) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64data = reader.result.split(",")[1];
              downloadFile(base64data, "boleto.pdf");
            };
            reader.readAsDataURL(blob);
          })
          .catch((error) => console.error("Error fetching the file:", error));
      })
      .catch(() => {
        window.alert("A sua sessão expirou");
        window.location.href = "/portal";
      });
  };

  const downloadFile = (base64Data, fileName) => {
    const linkSource = `data:application/pdf;base64,${base64Data}`;
    const iframeContainer = document.createElement("div");
    iframeContainer.style.width = "100%";
    iframeContainer.style.height = "100vh";
    iframeContainer.style.position = "fixed";
    iframeContainer.style.top = "0";
    iframeContainer.style.left = "0";
    iframeContainer.style.backgroundColor = "rgba(0,0,0,0.8)";
    iframeContainer.style.zIndex = "9999";
    iframeContainer.style.display = "flex";
    iframeContainer.style.justifyContent = "center";
    iframeContainer.style.alignItems = "center";

    const closeButton = document.createElement("button");
    closeButton.innerHTML = "X";
    closeButton.style.position = "absolute";
    closeButton.style.top = "20px";
    closeButton.style.right = "20px";
    closeButton.style.padding = "10px 20px";
    closeButton.style.backgroundColor = "#fff";
    closeButton.style.border = "none";
    closeButton.style.borderRadius = "5px";
    closeButton.style.cursor = "pointer";
    closeButton.onclick = () => document.body.removeChild(iframeContainer);

    const iframe = document.createElement("iframe");
    iframe.src = linkSource;
    iframe.style.width = "90%";
    iframe.style.height = "90%";
    iframe.style.border = "none";

    iframeContainer.appendChild(closeButton);
    iframeContainer.appendChild(iframe);
    document.body.appendChild(iframeContainer);
  };

  let dados_novos = dados.filter(
    (unico) => unico[8] == null && unico[10] && unico[4] !== "NOTA",
  );

  const is_null = dados_novos.length === 0;

  if (is_null) {
    return (
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography color="text.secondary">
          Sua situação está em dia! Não há boletos pendentes.
        </Typography>
      </Box>
    );
  }

  dados_novos = dados_novos.sort(function (a, b) {
    let aa = a[2].split("/").reverse().join();
    let bb = b[2].split("/").reverse().join();
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });

  const containsOnly = getGridStringOperators().filter(
    (op) => op.value === "contains",
  );

  const columns = [
    {
      field: "nota",
      headerName: "Nº Nota",
      flex: 1,
      minWidth: 100,
      filterOperators: containsOnly,
      sortable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "vencimento",
      headerName: "Data de Vencimento",
      flex: 1,
      minWidth: 150,
      filterOperators: containsOnly,
      sortable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "valor",
      headerName: "Valor Total",
      flex: 1,
      minWidth: 120,
      filterOperators: containsOnly,
      sortable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 130,
      sortable: true,
      filterOperators: containsOnly,
      align: "center",
      headerAlign: "center",

      renderCell: (params) => (
        <Chip
          color={
            params.value === "Aberto" || params.value === "DAYCOVAL"
              ? "success"
              : params.value === "VENDOR"
                ? "warning"
                : "error"
          }
          size="small"
          label={params.value}
          className="status-chip"
          sx={{
            fontWeight: 500,
            fontSize: "0.75rem",
            height: "24px",
            "& .MuiChip-label": {
              px: 1.5,
            },
          }}
        />
      ),
    },

    {
      field: "actions",
      headerName: "Ver Boleto",
      flex: 1,
      minWidth: 120,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Tooltip title="Clique para ver o boleto" arrow>
            <IconButton
              onClick={() =>
                cons_boleto(
                  params.row.nufin,
                  params.row.codbco,
                  params.row.status,
                  params.row.linha_digitavel,
                  params.row.nossonum,
                )
              }
              sx={{
                "&:hover": {
                  backgroundColor: "primary.light",
                  "& .MuiSvgIcon-root": {
                    color: "primary.main",
                  },
                },
              }}
            >
              <PaidIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Enviar para WhatsApp" arrow></Tooltip>
        </Box>
      ),
    },
  ];

  const rows = dados_novos.map((linha, index) => ({
    id: index,
    nota: linha[0],
    vencimento: linha[2],
    valor: linha[4] === "VENDOR" ? "" : linha[3],
    status: linha[4] === "Em aberto" ? "Aberto" : linha[4],
    nufin: linha[5],
    codbco: linha[6],
    linha_digitavel: linha[10],
    nossonum: linha[11],
  }));

  const handleSelectionChange = (newSelectionModel) => {
    const selectedRowData = rows.filter((row) =>
      newSelectionModel.includes(row.id),
    );
    setSelectedRows(selectedRowData);
  };

  const renderMobileView = () => {
    if (is_null) {
      return (
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Typography color="text.secondary">
            Sua situação está em dia! Não há boletos pendentes.
          </Typography>
        </Box>
      );
    }

    return (
      <Box sx={{ p: 1 }}>
        {rows.map((row) => {
          const isSelected = selectedRows.some((r) => r.id === row.id);
          return (
            <Card
              key={row.id}
              variant="outlined"
              sx={{
                mb: 2,
                p: 2,
                backgroundColor: isSelected
                  ? "action.selected"
                  : "background.paper",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isSelected}
                    onChange={() => {
                      const newSelection = isSelected
                        ? selectedRows.filter((r) => r.id !== row.id)
                        : [...selectedRows, row];
                      setSelectedRows(newSelection);
                    }}
                  />
                }
                label={
                  <Box
                    sx={{
                      width: "100%",
                      fontSize: "0.512rem",
                      display: "flex",
                      flexDirection: "row",
                      gap: "6px",
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 500,
                          color: "text.primary",
                        }}
                      >
                        Nota: {row.nota}
                      </Typography>

                      <Chip
                        color={
                          row.status === "Aberto"
                            ? "success"
                            : row.status === "VENDOR"
                              ? "warning"
                              : "error"
                        }
                        size="small"
                        label={row.status}
                        sx={{
                          fontWeight: 500,
                          transition: "all 0.2s",
                          "&:hover": {
                            transform: "scale(1.05)",
                          },
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          color: "text.secondary",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        Vencimento: {row.vencimento}
                      </Typography>

                      <Typography
                        variant="body1"
                        sx={{
                          color: "text.secondary",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        Valor: {row.valor}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 1,
                      }}
                    >
                      <IconButton
                        size="medium"
                        onClick={() =>
                          cons_boleto(
                            row.nufin,
                            row.codbco,
                            row.status,
                            row.linha_digitavel,
                            row.nossonum,
                          )
                        }
                        sx={{
                          color: "primary.main",
                          transition: "all 0.2s",
                          "&:hover": {
                            backgroundColor: "primary.light",
                            transform: "scale(1.1)",
                          },
                        }}
                      >
                        <PaidIcon />
                      </IconButton>
                    </Box>
                  </Box>
                }
              />
            </Card>
          );
        })}
      </Box>
    );
  };

  const renderMobileActionButtons = () => (
    <Paper
      elevation={1}
      sx={{
        mt: 2,
        p: 2,
        backgroundColor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.05)"
            : "rgba(0, 0, 0, 0.02)",
        borderRadius: 2,
        display: selectedRows.length > 0 ? "flex" : "none",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <LoadingButton
        fullWidth
        size="medium"
        variant="outlined"
        startIcon={<WhatsAppIcon />}
        onClick={() => {
          setWhatsappModal(true);
        }}
        sx={{
          borderColor: "#25D366",
          color: "#25D366",
          "&:hover": {
            borderColor: "#128C7E",
            backgroundColor: "rgba(37, 211, 102, 0.04)",
          },
        }}
      >
        Enviar via WhatsApp
      </LoadingButton>

      <LoadingButton
        fullWidth
        size="medium"
        variant="outlined"
        startIcon={<EmailIcon />}
        onClick={() => setEmailappModal(true)}
        color="primary"
      >
        Enviar via Email
      </LoadingButton>

      <LoadingButton
        fullWidth
        size="medium"
        variant="contained"
        startIcon={<DownloadForOfflineIcon />}
        loading={loadingAllBankSlips}
        onClick={handleDownloadAllBankSlip}
        loadingPosition="start"
        color="primary"
      >
        {loadingAllBankSlips ? "Baixando..." : "Baixar Boletos"}
      </LoadingButton>
    </Paper>
  );

  return (
    <Box sx={{ width: "100%" }}>
      <React.Fragment>
        <AlertSnack
          open={openSnack}
          tipo={snackType}
          texto={snackMessage}
          onClose={() => setOpenSnack(false)}
        />

        <Chip
          color="warning"
          sx={{ mb: 2, fontSize: "0.75rem" }}
          label={
            <span>
              Atenção: Boletos Vendor não aparecem aqui. Entre em contato via{" "}
              <a
                href={`https://wa.me/${supportNumber.whatsApp}/?text=Olá, preciso de ajuda com meus boletos Vendor`}
                target="_blank"
                rel="noreferrer"
                style={{ color: "inherit", fontWeight: "bold" }} // Dica: herda a cor do chip e dá um destaque
              >
                WhatsApp
              </a>{" "}
              caso necessário
            </span>
          }
        />

        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, pl: 1 }}
        >
          <InfoIcon color="action" fontSize="small" />
          <Typography variant="body2" color="text.secondary">
            Selecione os boletos desejados clicando nas caixas de seleção
            abaixo.
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            pb: isMobile && selectedRows.length > 0 ? 8 : 0,
          }}
        >
          {!isMobile && selectedRows.length > 0 && (
            <Paper
              elevation={0}
              sx={{
                p: { xs: 1, sm: 2 },
                mb: 2,
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark"
                    ? "rgba(255, 255, 255, 0.05)"
                    : "rgba(0, 0, 0, 0.02)",
                borderRadius: 2,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1,
                justifyContent: { xs: "stretch", sm: "flex-end" },
              }}
            >
              <LoadingButton
                size="small"
                variant="outlined"
                startIcon={<WhatsAppIcon />}
                onClick={() => {
                  setWhatsappModal(true);
                }}
                sx={{
                  borderColor: "#25D366",
                  color: "#25D366",
                  "&:hover": {
                    borderColor: "#128C7E",
                    backgroundColor: "rgba(37, 211, 102, 0.04)",
                  },
                }}
              >
                WhatsApp
              </LoadingButton>

              <LoadingButton
                size="small"
                variant="outlined"
                startIcon={<EmailIcon />}
                onClick={() => setEmailappModal(true)}
                color="primary"
              >
                Email
              </LoadingButton>

              <LoadingButton
                size="small"
                variant="contained"
                startIcon={<DownloadForOfflineIcon />}
                loading={loadingAllBankSlips}
                onClick={handleDownloadAllBankSlip}
                loadingPosition="start"
                color="primary"
              >
                {loadingAllBankSlips ? "Baixando..." : "Baixar"}
              </LoadingButton>
            </Paper>
          )}

          <Box
            sx={{
              width: "100%",
              backgroundColor: (theme) =>
                theme.palette.mode === "dark"
                  ? theme.palette.background.default
                  : "#f5f5f5",
              borderRadius: 2,
              overflow: "hidden",
              height: { xs: "auto", sm: "400px" },
              position: "relative",
            }}
          >
            {isMobile ? (
              <>
                {renderMobileView()}
                {renderMobileActionButtons()}
              </>
            ) : (
              <StyledDataGrid
                rows={rows}
                columns={columns}
                pageSize={100}
                rowsPerPageOptions={[25, 50, 100]}
                checkboxSelection
                disableSelectionOnClick
                getRowHeight={() => "auto"}
                localeText={ptBRGrid}
                onRowSelectionModelChange={handleSelectionChange}
                rowSelectionModel={selectedRows.map((row) => row.id)}
                components={{
                  NoRowsOverlay: () => (
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        p: 2,
                        color: "text.secondary",
                        fontSize: "0.875rem",
                      }}
                    >
                      Sua situação está em dia! Não há boletos pendentes.
                    </Box>
                  ),
                }}
                disableVirtualization={isMobile}
                autoHeight={isMobile}
                style={{ height: "100%" }}
              />
            )}
          </Box>
        </Box>

        <Dialog open={whatsappModal} onClose={() => setWhatsappModal(false)}>
          <DialogTitle>
            Enviar Boleto via WhatsApp
            <Typography
              variant="caption"
              display="block"
              sx={{ mt: 1, color: "text.secondary" }}
            >
              Digite o número com DDD (apenas números)
            </Typography>
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Número do WhatsApp"
              type="tel"
              fullWidth
              variant="outlined"
              value={phone}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 11) {
                  setPhone(value);
                  validatePhone(value);
                  setAttemptedExtraDigits(false);
                } else {
                  setAttemptedExtraDigits(true);
                  setSnackType("warning");
                  setSnackMessage("O número não pode ter mais que 11 dígitos");
                  setOpenSnack(true);
                }
              }}
              placeholder="11999999999"
              error={!!phoneError || attemptedExtraDigits}
              helperText={
                phoneError || (attemptedExtraDigits ? "Número muito longo" : "")
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <WhatsAppIcon sx={{ color: "#25D366" }} />
                  </InputAdornment>
                ),
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              inputProps={{
                maxLength: 11,
              }}
            />
            {whatsappError && (
              <Alert
                severity="error"
                sx={{
                  mt: 2,
                  "& .MuiAlert-message": {
                    width: "100%",
                  },
                }}
              >
                <Typography variant="subtitle2">
                  Erro ao enviar mensagem
                </Typography>
                <Typography variant="body2">{whatsappError}</Typography>
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setWhatsappModal(false);
                setPhone("");
                setPhoneError("");
                setWhatsappError("");
              }}
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={sendingWhatsapp}
              onClick={handleWhatsAppSend}
              variant="contained"
              disabled={!isPhoneValid}
              sx={{
                bgcolor: (theme) => theme.palette.primary.main,
                "&:hover": {
                  bgcolor: "#128C7E",
                },
              }}
            >
              Enviar
            </LoadingButton>
          </DialogActions>
        </Dialog>

        <Dialog open={emailappModal} onClose={() => setEmailappModal(false)}>
          <DialogTitle>Enviar Boleto via E-mail</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Email"
              type="email"
              fullWidth
              variant="standard"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="exemple@email.com"
            />
            {emailError && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {emailError}
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEmailappModal(false)}>Cancelar</Button>
            <LoadingButton
              loading={sendingEmail}
              onClick={handleEmailSend}
              variant="contained"
            >
              Enviar
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </Box>
  );
}

export default Boletos;
